/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://pmskqikwdrgqnf2nkluy4ql3ce.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kwe3xh5c4vdg5pl2phr2asgq4u",
    "aws_cognito_identity_pool_id": "eu-central-1:4c04c10f-d42f-4107-bc89-726d7a517f33",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_cwhzfLyxu",
    "aws_user_pools_web_client_id": "27ps809s70skm66ku75ttt7fqc",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
